import i18n from "@/i18n";
const isEn = i18n.locale === "en";
const {
  vbot: vbotLang,
  productNameDic: productNameDicLang,
  trait: traitLang,
  paintDetailList: paintDetailListLang,
  paintStandardList: paintStandardListLang,
  GData: GDataLang,
  windowMembraneList: windowMembraneListLang,
  colorChangeData: colorChangeDataLang,
  skylightData: skylightDataLang
} = i18n.t("pruduct-dict");
// 特质
const trait = [
  {
    id: "trait-1",
    title: "高炫亮",
    bgc:
      "https://img.topsfilm.com/newportal/img/product/Paint/detail-public-1.png",
    text:
      "德国拓弗第四代V+涂层技术，有效提升原厂漆亮度30%以上；<br/>TPU基材具备高强弹性，可有效防御石子弹射，轻微摩擦划痕<br/>自动修复；保持车身光泽靓丽，守护漆面无痕如新。"
  },
  {
    id: "trait-2",
    title: "强抗污",
    bgc:
      "https://img.topsfilm.com/newportal/img/product/Paint/detail-public-2.png",
    text:
      "纳米级抗污技术，搭配仿生学原理，打造强劲抗粉尘<br/>能力和抗黏附能力，疏水自洁，抗污防水垢。"
  },
  {
    id: "trait-3",
    title: "耐黄变",
    bgc:
      "https://img.topsfilm.com/newportal/img/product/Paint/detail-public-3.png",
    text:
      "采用光学级TPU+基材，阻隔紫外线穿透，抗氧化、抗高温<br/>暴晒，有效保护原厂漆质感和光泽，防止老化和褪色。"
  }
];
if (isEn) {
  trait.forEach((item, index) => {
    item.title = traitLang[index].title;
    item.text = traitLang[index].text;
  });
}

const vbot = {
  bgc:
    "https://img.topsfilm.com/newportal/img/product/Paint/detail-tour1-2.png",
  text:
    "TOPPF拓弗首席涂层研发高级工程师<br/>来自世界著名的德国巴斯夫涂料公司，<br/>在德国拜耳化学公司研发部门的协助<br/>下，成功研发专有技术V+涂层。拓弗<br/>V+涂层经历实验室9600小时严格老<br/>化测试，可有效提升原厂漆亮度30%<br/>以上，让汽车漆面炫亮如初新。<br/>"
};
if (isEn) vbot.text = vbotLang;

const productNameDic = {
  Paint: "漆面保护膜",
  G: "G速膜(汽车窗膜)",
  ColorChange: "改色膜",
  Colorful: "炫彩膜",
  SkyLight: "天窗铠甲",
  HeadlightFilm:"大灯膜",
};

if (isEn) {
  Object.assign(productNameDic, productNameDicLang);
}

// 漆面保护膜
//    漆面详情
const paintDetailList = [
  {
    id: "Paint-detail-1",
    "text-us": "TOUR PLUS",
    "text-cn": "拓+",
    "thickness": "Thickness: 10 mil",
    "thickness-cn": "厚度: 10 mil",
    warrantyPeriod: "质保时间:10 年",
    warrantyPeriod_en: "Warranty Period:10 Years",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/paint-1.png",
    detailSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/tour%2B.png",
    detail: {
      duetime: 10, // 质保期限
      title: "C位主咖",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/Paint/title.png",
      starimg:
        "https://img.topsfilm.com/newportal/img/product/10.png",
      introduceSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/plusdetail.png",
      vtop: {
        bgc:
          "https://img.topsfilm.com/newportal/img/product/Paint/detail-tour1-1.png",
        text:
          "采用TOPPF拓弗独有的V+涂层技术<br/>和TPU+10mil加厚基材，极致保护。<br/>具有超强弹性、高性能抗腐蚀、自我<br/>修复、抗污染、抗刮擦和高炫亮的特性。"
      },
      vbot,
      trait
    }
  },
  {
    id: "Paint-detail-2",
    "text-us": "TOUR",
    "text-cn": "拓",
    "thickness": "Thickness: 9 mil",
    "thickness-cn": "厚度: 9 mil",
    warrantyPeriod: "质保时间:10 年",
    warrantyPeriod_en: "Warranty Period:10 Years",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/paint-2.png",
    detailSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/tour%2B.png",
    detail: {
      duetime: 10, // 质保期限
      title: "品质尊享",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/Paint/title.png",
      starimg:
        "https://img.topsfilm.com/newportal/img/product/10.png",
        introduceSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/TOURD.png",
      vtop: {
        bgc:
          "https://img.topsfilm.com/newportal/img/product/Paint/detail-tour-1.png",
        text:
          "采用TOPPF拓弗独有V+涂层技术和<br/>TPU+优质基材。具有高强度抗腐蚀、<br/>自我修复、抗污染、抗刮擦和高炫亮<br/>的特性。"
      },
      vbot,
      trait
    }
  },
  {
    id: "Paint-detail-3",
    "text-us": "PHANTOM MATTE",
    "text-cn": "幻影哑光",
    "thickness": "Thickness: 8 mil",
    "thickness-cn": "厚度: 8 mil",
    warrantyPeriod: "质保时间:10 年",
    warrantyPeriod_en: "Warranty Period:10 Years",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/paint-3.png",
    detailSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/PHANTOM%20MATTE.png",
    detail: {
      duetime: 10, // 质保期限
      title: "奢雅顶配",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/Paint/title.png",
      starimg:
        "https://img.topsfilm.com/newportal/img/product/10.png",
        introduceSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/PHANTOM%20MATTED.png",
        vtop: {
        bgc:
          "https://img.topsfilm.com/newportal/img/product/Paint/detail-yaguang.png",
        text:
          "具有哑光绸缎质感，由PHANTOM幻影<br/>系列相同V+涂层技术加铸造消光工艺<br/>精制而成，在为车身提供强大保护的<br/>同时，更带来不俗的视觉体验，质感</br>非凡，彰显优雅。"
      },
      vbot,
      trait
    }
  },
  {
    id: "Paint-detail-4",
    "text-us": "PHANTOM",
    "text-cn": "幻影",
    "thickness": "Thickness: 8 mil",
    "thickness-cn": "厚度: 8 mil",
    warrantyPeriod: "质保时间:10 年",
    warrantyPeriod_en: "Warranty Period:10 Years",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/paint-4.png",
    detailSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/PHANTOM.png",
    detail: {
      introduceSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/PHANTOMD.png",
      duetime: 10, // 质保期限
      title: "高端玩家",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/Paint/title.png",
      starimg:
        "https://img.topsfilm.com/newportal/img/product/10.png",
        vtop: {
        bgc:
          "https://img.topsfilm.com/newportal/img/product/Paint/detail-huanying.png",
        text:
          "高透炫亮漆面保护膜，采用TOPPF拓弗<br/>独有V+涂层技术，其主要特点为高炫亮、<br/>强抗污， 耐黄变。"
      },
      vbot,
      trait
    }
  },
  {
    id: "Paint-detail-5",
    "text-us": "FEDER",
    "text-cn": "羽裳",
    "thickness": "Thickness: 8 mil",
    "thickness-cn": "厚度: 8 mil",
    warrantyPeriod: "质保时间:6 年",
    warrantyPeriod_en: "Warranty Period:6 Years",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/paint-5.png",
    detailSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/FEDER.png",
    detail: {
      introduceSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/FEDERD.png",
      duetime: 6, // 质保期限
      title: "提车必备",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/Paint/title.png",
      starimg:
        "https://img.topsfilm.com/newportal/img/product/6.png",
      vtop: {
        bgc:
          "https://img.topsfilm.com/newportal/img/product/Paint/detail-yushang.png",
        text:
          "PDI 渠道专供产品，致密V+涂层可抵御<br/>各种污染，高透、炫亮、耐久稳定，有<br/>效提升原厂漆光泽度，是PDI 渠道合作<br/>伙伴的甄致之选。"
      },
      vbot,
      trait
    }
  },
  // {
  //   id: "Paint-detail-6",
  //   "text-us": "F1",
  //   "text-cn": "F1",
  //   "thickness":"Thickness: 8 mil",
  //   "text-src":
  //     "https://img.topsfilm.com/newportal/img/product/Paint/paint-f1.png",
  //   src: "https://img.topsfilm.com/newportal/img/product/Paint/paint-6.png",
  //   detail: {
  //     duetime: 10, // 质保期限
  //     title: "匠心守护",
  //     titlesrc:
  //       "https://img.topsfilm.com/newportal/img/product/Paint/title.png",
  //     starimg:
  //       "https://img.topsfilm.com/newportal/img/product/Paint/F1star.png",
  //     vtop: {
  //       bgc:
  //         "https://img.topsfilm.com/newportal/img/product/Paint/detail-f1.png",
  //       text:
  //         "采用德国拓弗第四代V+ 涂层纳米胶囊<br/>技术，耐黄变，易施工，常温自修复，<br/>物有所值，门店优选。"
  //     },
  //     vbot,
  //     trait
  //   }
  // },
  {
    id: "Paint-detail-6",
    "text-us": "F0",
    "text-cn": "F0",
    "thickness": "Thickness: 8 mil",
    "thickness-cn":"厚度: 8 mil",
    "text-src":
      "https://img.topsfilm.com/newportal/img/product/Paint/F0Name.png",
      warrantyPeriod: "质保时间:6 年",
      warrantyPeriod_en: "Warranty Period:6 Years",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/F0.png",
    detailSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/F0.png",
    detail: {
      introduceSrc:"https://img.topsfilm.com/newportal/img/product/Paint/details/F0D.png",

      duetime: 6, // 质保期限
      title: "匠心守护",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/Paint/title.png",
      starimg:
        "https://img.topsfilm.com/newportal/img/product/6.png",
      vtop: {
        bgc:
          "https://img.topsfilm.com/newportal/img/product/Paint/detail-f1.png",
        text:
          "采用德国拓弗第四代V+ 涂层纳米胶囊<br/>技术，耐黄变，易施工，常温自修复，<br/>物有所值，门店优选。"
      },
      vbot,
      trait
    }
  }
];

if (isEn) {
  paintDetailList.forEach((item, index) => {
    // TODO
    // item['text-cn'] = paintDetailListLang[index]["text-cn"]
    item.detail.title = paintDetailListLang[index].title;
    item.detail.vtop.text = paintDetailListLang[index].content;
  });
}

//    漆面展示
const paintStandardList = [
  {
    id: "paint-show-1",
    "text-us": "GLOSSINESS",
    "text-cn": "炫亮 - 提升光泽",
    content:
      "德国拓弗第四代V+ 涂层纳米胶囊技术，配上光学级TPU+基材， 高亮度、高清晰度，有效<br/>提升油漆表面光泽度。",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/G.png",
    letter: "G"
  },
  {
    id: "paint-show-2",
    "text-us": "ENDURANCE",
    "text-cn": "抗污 - 隔绝污染",
    content:
      "德国拓弗第四代V+ 涂层纳米胶囊技术，强劲抗粉尘能力和抗黏附能力，防止鸟粪和大气中粉尘侵蚀，有效保护原厂漆不受污染。",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/E.png",
    letter: "E"
  },
  {
    id: "paint-show-3",
    "text-us": "RECOVERABILITY",
    "text-cn": "无痕 - 恒久如新",
    content:
      "德国拓弗第四代V+ 涂层纳米胶囊技术，常温自修复功能，小刮小擦自动修复，有效保持漆面无痕如新。",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/R.png",
    letter: "R"
  },
  {
    id: "paint-show-4",
    "text-us": "MITIGATION",
    "text-cn": "护色 - 防止褪色",
    content:
      "德国拓弗第四代V+ 涂层纳米胶囊技术，超强紫外线吸收，TPU+基材，阻隔紫外线穿透，有效保护原厂漆、防老化和褪色。",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/M.png",
    letter: "M"
  },
  {
    id: "paint-show-5",
    "text-us": "ARMOUR",
    "text-cn": "遁甲 - 抵御刮擦",
    content:
      "TPU+基材，超强弹性，有效防御刮擦和<br/>石子弹射，保护原厂车漆不受伤害。",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/A.png",
    letter: "A"
  },
  {
    id: "paint-show-6",
    "text-us": "NANOTECHNOLOGY",
    "text-cn": "清洁 – 自洁防污",
    content:
      "德国拓弗第四代V+ 涂层纳米胶囊技术，优良的疏水自洁功能，有效防止水垢对车漆的污染。",
    src: "https://img.topsfilm.com/newportal/img/product/Paint/N.png",
    letter: "N"
  }
];

if (isEn) {
  paintStandardList.forEach((item, index) => {
    item["text-cn"] = paintStandardListLang[index]["text-cn"];
    item.content = paintStandardListLang[index].content;
  });
}

// G速膜
const GData = {
    //色界系列
  Dynamic: {

    id: "G-1",
    title: "色界系列 Dynamic Series：智能变色",
    src:
      "https://img.topsfilm.com/newportal/img/product/G/color-bound-sejie.png",
    content: [
      {
        id: "Dynamic-1",
        model: "CW75-30",
        thickness: " 厚度: 5mil",
        warrantyPeriod: "质保时间:10 年",
        infraredBlockingRate: "90%",

        visibleLightTransmittance: "透光率:75%-30%",
      },
      {
        id: "Dynamic-2",
        model: "CW60-15",
        thickness: " 厚度: 4mil",
        warrantyPeriod: "质保时间:10 年",
        infraredBlockingRate: "90%",
        visibleLightTransmittance: "透光率:60%-15%",
      }
    ],
    detail: {
      productTitle: "CW75-30 CW60-15",
      detailvalue: "https://img.topsfilm.com/newportal/img/product/G/CW75detailvalue.png",
      gtop: {
        bgc: "https://img.topsfilm.com/newportal/img/product/G/Dynamic-top.png",
        text:
          "色界™系列采用拓弗勒专有技术，能随<br/>着光线的强弱实现智能变色，同时拥有<br/>信号零阻隔、高效隔热、安全防爆和隔<br/>绝紫外线的性能。10年原厂质保。"
      },
      gbot: {
        title: "色界™ 系列产品优势",
        advantage: [
          { title: "Talented", text: "智能防眩，逸趣畅行。" },
          { title: "Outstanding", text: "微级调控，自由通透。 " },
          { title: " Prestigious", text: "随光而变，舒适尊享。" },
          { title: "Safety", text: "快速反应，智守安全。 " },
          { title: " Flexible", text: " 随心灵动，无惧强光。" }
        ],
        bgc: "https://img.topsfilm.com/newportal/img/product/G/bgtu.png",
        slogan:"- Infinite vision, intelligent brightness",
        tableData: [
          {
            model: "CW75-30",
            visibleLightTransmittance: "75%-30%",
            totalSolarBarrier: "55%",
            infraredBlockingRate:"90%",
            reflectiveRate: "8%",
            UVBarrier: ">99.99%",
            "5gSignalPassRate": "100%",
            thickness: "5mil",
            warrantyPeriod: "10"
          },
          {
            model: "CW60-15",
            visibleLightTransmittance: "60%-15%",
            totalSolarBarrier: "65%",
            infraredBlockingRate:"90%",
            reflectiveRate: "8%",
            UVBarrier: ">99.99%",
            "5gSignalPassRate": "100%",
            thickness: "5mil",
            warrantyPeriod: "10"
          }
        ]
      }
    }
  },
  //晶曜®️尊享系列
  SuperDiamond: {
    // 晶曜®️尊享系列
    id: "G-2",
    title: "晶曜®️尊享系列 Super Diamond Series：安全防护",
    src:
      "https://img.topsfilm.com/newportal/img/product/G/color-bound-jingyao.png",
    content: [
      {
        id: "SuperDiamond-1",
        model: "T80",
        thickness: " 厚度: 4mil",
        warrantyPeriod: "质保时间:10 年",
        infraredBlockingRate: "95%",
        visibleLightTransmittance: "透光率:80%",
      },
      {
        id: "SuperDiamond-2",
        model: "T40",
        thickness: " 厚度: 4mil",
        warrantyPeriod: "质保时间:10 年",
        infraredBlockingRate: "90%",
        visibleLightTransmittance: "透光率:38%",

      },
      {
        id: "SuperDiamond-3",
        model: "T15",
        thickness: " 厚度: 4mil",
        warrantyPeriod: "质保时间:10 年",
        infraredBlockingRate: "92%",
    visibleLightTransmittance: "透光率:15%",
      }
    ],
    detail: {
      productTitle: "T80 T40 T15",
      detailvalue: "https://img.topsfilm.com/newportal/img/product/G/T80detailvalue.png",
      gtop: {
        bgc:
          "https://img.topsfilm.com/newportal/img/product/G/SuperDiamond-top.png",
        text:
          "晶曜®尊享系列采用拓弗专利纳米石墨烯<br/>黑金膜层，无信号阻隔干扰，非金属材质，<br/>100%不氧化，颜色恒定，无褪色之忧。<br/>非金属“膜”术，手机/GPS/ETC信号满格，<br/>精准对焦5G时代高科技智慧交通，高度适<br/>配新能源汽车，为全面开启无人驾驶技术<br/>保驾护航。高透光、高清晰度、低反光，<br/>提供最清晰的前挡视野，保障夜间安全驾<br/>驶。10年原厂质保，耐用持久。"
      },
      gbot: {
        title: "晶曜®️尊享系列产品优势",
        advantage: [
          { text: "5G信号零阻隔，精准对接智能出行。" },
          {text:    "黑金安全网，高科技防护。"},
          {text:"顶级隔热，强力防晒。"},
          {text: "高紫外线隔绝，减少光老化危害。 "},
          {text:"高清晰度，视野通畅无阻。"},
          {text:"杜绝氧化，耐久不变。"},
          {text:"10年原厂质保，耐用持久。"},
        ],
        slogan:"- Crystal enjoyment window film,   enjoy your travel",
        bgc:
          "https://img.topsfilm.com/newportal/img/product/G/SuperDiamond-bot.png",
        tableData: [
          {
            model: "T80",
            visibleLightTransmittance: "80%",
            totalSolarBarrier: "56%",
            infraredBlockingRate:"95%",
            reflectiveRate: "9%",
            UVBarrier: ">99%",
            "5gSignalPassRate": "100%",
            thickness: "4mil",
            warrantyPeriod: "10" //'终身质保'
          },
          {
            model: "T40",
            visibleLightTransmittance: "38%",
            totalSolarBarrier: "59%",
            infraredBlockingRate:"90%",
            reflectiveRate: "9%",
            UVBarrier: ">99%",
            "5gSignalPassRate": "100%",
            thickness: "4mil",
            warrantyPeriod: "10" //'终身质保'
          },
          {
            model: "T15",
            visibleLightTransmittance: "15%",
            totalSolarBarrier: "72%",
            infraredBlockingRate:"92%",
            reflectiveRate: "6%",
            UVBarrier: ">99%",
            "5gSignalPassRate": "100%",
            thickness: "4mil",
            warrantyPeriod: "10" //'终身质保'
          }
        ]
      }
    }
  },
  //晶曜®️系列 Diamond Series
  Diamond: {
    //晶曜®️系列
    id: "G-3",
    title: "晶曜®️系列 Diamond Series：高效隔热",
    src:
      "https://img.topsfilm.com/newportal/img/product/G/color-bound-jingyao.png",
    content: [
      {
        id: "Diamond-1",
        model: "O80",
        thickness: " 厚度: 2mil",
        warrantyPeriod: "质保时间:10 年",
        visibleLightTransmittance: "透光率:80%",

      },
      {
        id: "Diamond-2",
        model: "O25",
        thickness: " 厚度: 2mil",
        warrantyPeriod: "质保时间:10 年",
        visibleLightTransmittance: "透光率:20%",
      },
      {
        id: "Diamond-3",
        model: "O15",
        thickness: " 厚度: 2mil",
        warrantyPeriod: "质保时间:10 年",
        visibleLightTransmittance: "透光率:15%",
      }
    ],
    detail: {
      detailvalue: "https://img.topsfilm.com/newportal/img/product/G/o80detailvalue.png",

      productTitle: "O80 O25 O15",
      gtop: {
        bgc: "https://img.topsfilm.com/newportal/img/product/G/Diamond-top.png",
        text:
          '晶曜®系列采用拓弗专利纳米石墨烯黑金<br/>膜层， 无信号阻隔干扰， 非金属材质，<br/>100%不氧化，颜色恒定，无褪色之忧。<br/>非金属"膜"术，手机/GPS/ETC信号满格，<br/>精准对焦5G时代高科技智慧交通，高度<br/>适配新能源汽车，为全面开启无人驾驶<br/>技术保驾护航。10年原厂质保，耐用持久。'
      },
      gbot: {
        title: "晶曜®️系列产品优势",
        advantage: [
          { text: "5G信号零阻隔，精准对接智能出行。" },
          { text: "顶级隔热，强力防晒。"},
          { text: "高紫外线隔绝，减少光老化危害。 "},
          { text: "高清晰度，视野通畅无阻。"},
          { text: "杜绝氧化，耐久不变。"},
          { text: "10年原厂质保。"},
        ],
        slogan:"- Crystal window film, shining life",
        bgc: "https://img.topsfilm.com/newportal/img/product/G/o80bgtu.png",
        tableData: [
          {
            model: "O80",
            visibleLightTransmittance: "80%",
            totalSolarBarrier: "55%",
            infraredBlockingRate:"95%",
            reflectiveRate: "9%",
            UVBarrier: ">99%",
            "5gSignalPassRate": "100%",
            thickness: "2mil",
            warrantyPeriod: "10"
          },
          {
            model: "O25",
            visibleLightTransmittance: "25%",
            totalSolarBarrier: "65%",
            infraredBlockingRate:"95%",
            reflectiveRate: "6%",
            UVBarrier: ">99%",
            "5gSignalPassRate": "100%",
            thickness: "2mil",
            warrantyPeriod: "10"
          },
          {
            model: "O15",
            visibleLightTransmittance: "15%",
            totalSolarBarrier: "70%",
            infraredBlockingRate:"95%",
            reflectiveRate: "6%",
            UVBarrier: ">99%",
            "5gSignalPassRate": "100%",
            thickness: "2mil",
            warrantyPeriod: "10"
          }
        ]
      }
    }
  },
  //晶悦系列 Crystal Series
  Crystal: {
    // 晶悦系列
    id: "G-4",
    title: "晶悦系列 Crystal Series：护肤防爆",
    src:
      "https://img.topsfilm.com/newportal/img/product/G/color-bound-jingyao.png",
    content: [
      {
        id: "Crystal-1",
        model: "S75",
        thickness: " 厚度: 2.5mil",
        warrantyPeriod: "质保时间:5 年",
        visibleLightTransmittance: "透光率:75%",
      },
      {
        id: "Crystal-2",
        model: "S35",
        thickness: " 厚度: 2.5mil",
        warrantyPeriod: "质保时间:5 年",
        visibleLightTransmittance: "透光率:35%",
      },
      {
        id: "Crystal-3",
        model: "S15",
        thickness: " 厚度: 2.5mil",
        warrantyPeriod: "质保时间:5 年",
        visibleLightTransmittance: "透光率:15%",
      }
    ],
    detail: {
      detailvalue: "https://img.topsfilm.com/newportal/img/product/G/S75detailvalue.png",

      productTitle: "S75 S35 S15",
      gtop: {
        bgc: "https://img.topsfilm.com/newportal/img/product/G/Crystal-top.png",
        text:
          "晶悦™系列采用拓弗专利纳米石墨烯黑金<br/>膜层，无信号阻隔干扰；具有独特光谱选<br/>择性反射，高效能隔热，迅速有效降低车<br/>内温度，全面提升驾驶舒适度，冰火世界<br/>一膜之隔，营造清凉舒爽车生活。有效阻<br/>隔99.9%的紫外线，提供相当于高达SPF<br/>1000+的防晒值，是日常防晒护肤品防晒<br/>值的30倍，高效防护肌肤健康，及爱车内<br/>饰的褪色老化，同时有效减少紫外线对眼<br/>睛的伤害，守护家人的健康和安全。5年<br/>原厂质保，杜绝氧化，耐久不变。"
      },
      gbot: {
        title: "晶悦™系列产品优势",
        advantage: [
          { text: "5G信号零阻隔，精准对接智能出行。" },
          { text: "全防护肤，强力防晒。"},
          { text: "100%紫外线隔绝，减少光老化危害。 "},
          { text: "高清晰度，视野通畅无阻。"},
          { text: "杜绝氧化，耐久不变。"},
          { text: "5年原厂质保。"}
        ],
        slogan:"- Crystal window film,  pleasing life",
        bgc: "https://img.topsfilm.com/newportal/img/product/G/s75bgtu.png",
        tableData: [
          {
            model: "S75",
            visibleLightTransmittance: "75%",
            totalSolarBarrier: "55%",
            infraredBlockingRate:"90%",
            reflectiveRate: "6%",
            UVBarrier: "100%",
            "5gSignalPassRate": "100%",
            thickness: "2.5mil",
            warrantyPeriod: "5"
          },
          {
            model: "S35",
            visibleLightTransmittance: "35%",
            totalSolarBarrier: "60%",
            infraredBlockingRate:"90%",
            reflectiveRate: "6%",
            UVBarrier: "100%",
            "5gSignalPassRate": "100%",
            thickness: "2.5mil",
            warrantyPeriod: "5"
          },
          {
            model: "S15",
            visibleLightTransmittance: "15%",
            totalSolarBarrier: "70%",
            infraredBlockingRate:"95%",
            reflectiveRate: "6%",
            UVBarrier: "100%",
            "5gSignalPassRate": "100%",
            thickness: "2.5mil",
            warrantyPeriod: "5"
          }
        ]
      }
    }
  },
  //F70 F30 F20 F10
  F:{
    // F系列
    id: "G-5",
    title: "GRYSTAL ENJOYMENT SERIES",
    src:
      "https://img.topsfilm.com/newportal/img/product/G/color-bound-jingyao.png",
    content: [
      {
        id: "F-70",
        model: "F70",
        thickness: " 厚度: 2mil",
        warrantyPeriod: "质保时间:7 年",
        visibleLightTransmittance: "透光率:70%",

      },
      {
        id: "F-30",
        model: "F30",
        thickness: " 厚度: 2mil",
        warrantyPeriod: "质保时间:7 年",
        visibleLightTransmittance: "透光率:30%",

      },
      {
        id: "F-20",
        model: "F20",
        thickness: " 厚度: 2mil",
        warrantyPeriod: "质保时间:7 年",
        visibleLightTransmittance: "透光率:20%",

      },
      {
        id: "F-10",
        model: "F10",
        thickness: " 厚度: 2mil",
        warrantyPeriod: "质保时间:7 年",
        visibleLightTransmittance: "透光率:10%",

      },
    ],
    detail: {
      detailvalue: "https://img.topsfilm.com/newportal/img/product/G/F70detailvalue.png",

      productTitle: "F70 F30 F20 F10",
      gtop: {
        bgc: "https://img.topsfilm.com/newportal/img/product/G/Diamond-top.png",
        text:
          "Diamond Series uses TOPS's patented nano-graphene<br/> black gold film layer, which has no signal blocking interference, non-metallic material, 100% non-oxidation, constant color, and no fading worries. It uses non-metallic 'film technology and allow full transmission of signal of mobile phone/GPS/ETC, which is significant for high-tech smart transportation in the 5G era, highly adapted to new energy vehicles, and escort for the full opening of unmanned driving technology. High light transmittance, high definition, low reflection, providing the clearest front view, ensuring safe driving at night. 10-year original factory warranty, durable and long-lasting."
      },
      gbot: {
        title: "Advantages of Crystal Series Products",
        advantage: [
          { text: "Nano-graphene black gold material" },
          { text: "High heat insulation and sun protection"},
          { text: "No signal blocking interference "},
          { text: "High light transmittance, high definition, low reflection"},
          { text: "7-year original factory warranty, durable and long-lasting."},
        ],
        slogan:"Crystal enjoyment window film, enjoy your travel",
        bgc: "https://img.topsfilm.com/newportal/img/product/G/F50bgtu.png",
        tableData: [
          {
            model: "F30",
            visibleLightTransmittance: "72%",
            totalSolarBarrier: "46%",
            infraredBlockingRate:"90%",
            reflectiveRate: "9%",
            UVBarrier: "99%",
            "5gSignalPassRate": "100%",
            thickness: "2mil",
            warrantyPeriod: "7 Years"
          },
          {
            model: "F30",
            visibleLightTransmittance: "30%",
            totalSolarBarrier: "50%",
            infraredBlockingRate:"88%",
            reflectiveRate: "8%",
            UVBarrier: "99%",
            "5gSignalPassRate": "100%",
            thickness: "2mil",
            warrantyPeriod: "7 Years"
          },
          {
            model: "F20",
            visibleLightTransmittance: "20%",
            totalSolarBarrier: "55%",
            infraredBlockingRate:"88%",
            reflectiveRate: "8%",
            UVBarrier: "99%",
            "5gSignalPassRate": "100%",
            thickness: "2mil",
            warrantyPeriod: "7 Years"
          },
          {
            model: "F10",
            visibleLightTransmittance: "10%",
            totalSolarBarrier: "70%",
            infraredBlockingRate:"88%",
            reflectiveRate: "8%",
            UVBarrier: "99%",
            "5gSignalPassRate": "100%",
            thickness: "2mil",
            warrantyPeriod: "7 Years"
          }
        ]
      }
    }
  }
};

if (isEn) {
  for (const k in GData) {
    GData[k].title = GDataLang[k].title;
    GData[k].content = GDataLang[k].content;
    GData[k].detail.gtop.text = GDataLang[k].topText;
    GData[k].detail.gbot.title = GDataLang[k].botTitle;

    GData[k].detail.gbot.advantage = GDataLang[k].botAdvantage;
    GData[k].detail.gbot.tableData.forEach(item => {
      item.warrantyPeriod += " Years";
    });
  }
} else {
  for (const k in GData) {
    GData[k].detail.gbot.tableData.forEach(item => {
      item.warrantyPeriod += "年";
    });
  }
}

//     窗膜
const windowMembraneList = [
  {
    id: "membrance-1",
    isBig: true,
    src: "https://img.topsfilm.com/newportal/img/product/G/newenergy2.png",
    titlesrc: "https://img.topsfilm.com/newportal/img/product/G/GGG.png",

  },
  {
    id: "membrance-2",
    text: "信号零阻隔，<br/>精准对接智能出行。",
    src: "https://img.topsfilm.com/newportal/img/product/G/signal.png",
    logo: "https://img.topsfilm.com/newportal/img/product/G/5g.png"
  },
  {
    id: "membrance-3",
    text: "纳米石墨烯黑金材料, <br/>高科技防护。",
    src: "https://img.topsfilm.com/newportal/img/product/G/S.png",
    logo: "https://img.topsfilm.com/newportal/img/product/G/safe.png"
  },
  {
    id: "membrance-4",
    text: "顶级隔热，强力防晒。",
    src: "https://img.topsfilm.com/newportal/img/product/G/UV-1.png",
    logo: "https://img.topsfilm.com/newportal/img/product/G/UV.png"
  },
  {
    id: "membrance-5",
    text: "高紫外线隔绝， <br/>减少光老化危害。 ",
    src: "https://img.topsfilm.com/newportal/img/product/G/Sun.png",
    logo: "https://img.topsfilm.com/newportal/img/product/G/gejue.png"
  },
  {
    id: "membrance-6",
    text: "高清晰度，视野通畅无阻。",
    src: "https://img.topsfilm.com/newportal/img/product/G/Y.png",
    logo: "https://img.topsfilm.com/newportal/img/product/G/safe.png"
  },
  {
    id: "membrance-7",
    text: "杜绝氧化，耐久不变。",
    src: "https://img.topsfilm.com/newportal/img/product/G/360-1.png",
    logo: "https://img.topsfilm.com/newportal/img/product/G/360.png"
  },
  {
    id: "membrance-8",
    text: "原厂长达10年质保。",
    src: "https://img.topsfilm.com/newportal/img/product/G/QA-1.png",
    logo: "https://img.topsfilm.com/newportal/img/product/G/QA.png"
  }
];

if (isEn) {
  windowMembraneList.forEach((item, index) => {
    if (index === 0) {
      item.titlesrc = windowMembraneListLang.titlesrc;
      item.src = windowMembraneListLang.newenergySrc;
    }

    item.text = windowMembraneListLang.content[index];
  });
}

// 改色膜
const colorChangeData = {


  // 系列
  series: {
    // 经典
    classic: {
      id: "classic",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-colorful.png",
      BaseMaterial: "PVC",
      BackMaterial: "160mg Paper",
      Thickness: "6.5mil",
      ShelfLife:"2 Years",
      data: [
        {
          id: "classic-1",
          "text-cn": "创世灰调系列",
          "text-us": "Genesis Grey Space Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-1.png"
        },
        {
          id: "classic-2",
          "text-cn": "玄夜哥特系列",
          "text-us": "Dark Gothic Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-2.png"
        },
        {
          id: "classic-3",
          "text-cn": "幻境星河系列",
          "text-us": "Splendid Galaxy Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-3.png"
        },
        {
          id: "classic-4",
          "text-cn": "灵感缪斯系列",
          "text-us": "Inspirational Muse Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-4.png"
        },
        {
          id: "classic-5",
          "text-cn": "幻光欧罗巴系列",
          "text-us": "Illusory Europe Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-5.png"
        },
        {
          id: "classic-6",
          "text-cn": "印象法兰西系列",
          "text-us": "Impressional France Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-6.png"
        },
        {
          id: "classic-7",
          "text-cn": "碧玺公爵系列",
          "text-us": "Duke Deluxe Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-7.png"
        },
        {
          id: "classic-8",
          "text-cn": "魅惑艳后系列",
          "text-us": "Glamorous Queens Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-8.png"
        },
        {
          id: "classic-9",
          "text-cn": "浪漫维纳斯系列",
          "text-us": "Romantic Venus Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-9.png"
        },
        {
          id: "classic-10",
          "text-cn": "梦幻梵高系列",
          "text-us": "Fantastic Van Gogh Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-10.png"
        }
      ]
    },
    //  尊享
    enjoy: {
      id: "enjoy",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/ColorChange/enjoy-colorful.png",
        BaseMaterial: "PVC",
        BackMaterial: "PET",
        Thickness: "6.5mil",
        ShelfLife:"3 Years",
      data: [
        {
          id: "enjoy-1",
          "text-cn": "创世灰调系列",
          "text-us": "Genesis Grey Space Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-1.png"
        },
        {
          id: "enjoy-2",
          "text-cn": "玄夜哥特系列",
          "text-us": "Dark Gothic Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-2.png"
        },
        {
          id: "enjoy-3",
          "text-cn": "幻境星河系列",
          "text-us": "Splendid Galaxy Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-3.png"
        },
        {
          id: "enjoy-4",
          "text-cn": "赤焰金沙系列",
          "text-us": "Golden Flame Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/enjoy-4.png"
        },
        {
          id: "enjoy-5",
          "text-cn": "圣域紫罗兰系列",
          "text-us": "Saint Violet Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/enjoy-5.png"
        },
        {
          id: "enjoy-6",
          "text-cn": "印象法兰西系列",
          "text-us": "Impressional France Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-6.png"
        },
        {
          id: "enjoy-7",
          "text-cn": "碧玺公爵系列",
          "text-us": "Duke Deluxe Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-7.png"
        },
        {
          id: "enjoy-8",
          "text-cn": "魅惑艳后系列",
          "text-us": "Glamorous Queens Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-8.png"
        },
        {
          id: "enjoy-9",
          "text-cn": "浪漫维纳斯系列",
          "text-us": "Romantic Venus Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-9.png"
        },
        {
          id: "enjoy-10",
          "text-cn": "梦幻梵高系列",
          "text-us": "Fantastic Van Gogh Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/classic-10.png"
        }
      ]
    },
    // 奢享
    luxurious: {
      id: "luxurious",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/ColorChange/luxurious-colorful.png",
        BaseMaterial: "TPU",
        BackMaterial: "PET",
        Thickness: "8.5mil",
        ShelfLife:"6 Years",
      data: [
        {
          id: "luxurious-1",
          "text-cn": "慕尼黑系列",
          "text-us": "Munich Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/luxurious-1.png"
        },
        {
          id: "luxurious-2",
          "text-cn": "柏林红系列",
          "text-us": "Berlin red Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/luxurious-2.png"
        },
        {
          id: "luxurious-3",
          "text-cn": "汉堡黄系列",
          "text-us": "Burger yellow Series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/luxurious-3.png"
        },
        {
          id: "luxurious-4",
          "text-cn": "莱茵蓝系列",
          "text-us": "Rhine blue series",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/luxurious-4.png"
        },
        {
          id: "luxurious-5",
          "text-cn": "科隆白系列",
          "text-us": "Cologne white Series",
          colorblack: true,
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/luxurious-5.png"
        },
        {
          id: "luxurious-6",
          "text-cn": "斯图加特珠光系列",
          "text-us": "Stuttgart pearlescent Series",
          colorblack: true,
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/luxurious-6.png"
        }
      ]
    },
    // 定制
    custom: {
      id: "custom",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/ColorChange/custom-colorful.png",
      data: [
        {
          id: "custom-1",
          "text-cn": "A类 局部简单拉花",
          "text-us": "Partial simple pull flower",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/custom-A.png"
        },
        {
          id: "custom-2",
          "text-cn": "B类 全车简单拉花",
          "text-us": "The whole car is simple to pull flowers",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/custom-B.png"
        },
        {
          id: "custom-3",
          "text-cn": "C类 全车拉花涂装",
          "text-us": "Full car pull flower painting",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/custom-C.png"
        },
        {
          id: "custom-4",
          "text-cn": "D类 全车彩绘涂装",
          "text-us": "Full car painted painting",
          src:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/custom-D.png"
        }
      ]
    }
  },
  // 改色膜
  membrane: {
    "1": [
      {
        id: "membrane-1",
        titlesrc:
          "https://img.topsfilm.com/newportal/img/product/ColorChange/colorfultext.png",
        text:
          "德国RAL Colours劳尔色彩专属定制<br/> RAL X TOPS <br/>德国劳尔色彩&德国拓弗勒战略合作",
        "src-upleft":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/logo.png",
        "src-upright":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/en/1-1.png",
        "src-lowleft":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/en/1-2.png",
        "src-lowright":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/en/1-3.png"
      }
    ],
    2: [
      {
        id: "membrane-2",
        title: "关于RAL Colours劳尔色彩",
        "text-t":
          "德国RAL劳尔公司成立于1925年，拥有近百年<br/>悠久历史。劳尔色彩在色彩标准化领域有着多<br/>项世界首创与独有技术，是全球通用的颜色世<br/>界的沟通语言。",
        "text-b":
          "至今，劳尔色彩已经成为专业色彩设计师眼中独立于制造<br/>商的全球颜色体系和颜色分类系统的同义词。劳尔色彩共<br/>有2,328个颜色，产品包括扇形色卡、颜色原标准、塑料<br/>颜色标准、颜色数字化软件、色彩设计与趋势书籍。<br/>在汽车油漆、车身涂料等多个工业领域，德国劳尔色彩被<br/>作为权威色彩标准使用。",
        "src-upleft":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/en/1-1.png",
        "src-upright":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/en/2-2.png",
        "src-lowleft":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/en/2-3.png",
        "src-lowright":
          "https://img.topsfilm.com/newportal/img/product/ColorChange/en/2-4.png"
      }
    ],
    3: [
      {
        id: "membrane-3",
        "title-normal": "2022+潮流色彩",
        "title-shadow": "2022+",
        data: [
          {
            id: "membrane-3-1",
            title:
              '<span style="color:#BCB456;">金钻风暴黄<br/>Vibrant Yellow</span>',
            "text-t":
              "从「 沙漠黄」到「 草垛黄」，从「 BV绿」到<br/>「凯莉绿」，2022+年的色彩趋势脉搏被黄绿<br/>色调牢牢拿捏。这种色彩充满自然旷野的气息，<br/>带着原始的生命能量，如风暴般横扫Dior、<br/>Sergio Hudson、Valentino、Versace、Prada<br/>等品牌的高定成衣系列，席卷着2022 年春夏<br/>时装发布的每一个秀场。 ",
            "text-c":
              "TOPS拓弗改色膜『金钻风暴黄』融合绿色与黄色，搭配金属漆面质感，形成独具魅力的吸睛色彩；<br/>它的出现为人们勾勒出一副生机勃勃的画面——一株生命力蓬勃的植物，勇敢地穿透风暴，向着金<br/>色的阳光野蛮生长，充斥着振奋人心的力量。",
            "text-b":
              '<span style="color:#BCB456; font-weight: 600">【金钻风暴黄】</span>源于劳尔实效系列RAL 250-M，<br/>代表了“生命与自然”主题，属于TOPS拓弗改色<br/>膜·尊享版的<span style="color:#BCB456; font-weight: 600">赤焰金沙系列</span>，它是一种活泼、新鲜<br/>的金属黄色，表面为金属质感，看起来生机勃勃，<br/>充满生命力。',
            "src-t":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-1.png",
            "src-c":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-2.png",
            "src-b":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-3.png"
          },
          {
            id: "membrane-3-2",
            title:
              '<span style="color:#9E8988;">沙漠玫瑰红<br/>Storm Red</span> ',
            "text-t":
              "自千禧年起步和社交媒体爆发以来，粉色成为主<br/>流色彩趋势饱受欢迎；其微妙而精致的气质、浪<br/>漫而柔和的魅力不仅让Kaws BFF、Mand Kaws、<br/>Air Jordan、TOYCITY、POPMART等潮品潮玩<br/>爱不释手，亦受到Hermès、Gucci、Yves Saint <br/>Laurent、CHANEL、Simone Rocha、Boss、<br/>Prada 等设计师和品牌的一致喜爱。",
            "text-c":
              "TOPS拓弗改色膜『沙漠玫瑰红』以世界殿堂级粉色玫瑰品种“龙沙宝石”的名称为创意，并在粉色<br/>色调的基础上融入高级灰调，营造更加沉稳而包容的色彩气质，打造优雅而柔和的色彩体验。",
            "text-b":
              '<span style="color:#9E8988; font-weight: 600">【沙漠玫瑰红】</span>源于劳尔设计体系颜色RAL 030<br/>60 10，代表了"融合与支持"主题，属于TOPS拓<br/>弗改色膜·尊享版的<span style="color:#9E8988; font-weight: 600">魅惑艳后系列</span>，它是一种微妙、<br/>优雅、平静的淡红色，表面为亮面质感，显得高<br/>贵而年轻，平静而感性。',
            "src-t":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-4.png",
            "src-c":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-5.png",
            "src-b":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-6.png"
          },
          {
            id: "membrane-3-3",
            title:
              '<span style="color:#4A5299;">圣域龙胆紫<br/>Vivid Violet<span/>',
            "text-t":
              "从「 沙漠黄」到「 草垛黄」，从「 BV绿」到「凯莉绿」， 2022 + 年的色彩趋势脉搏被黄绿色调牢牢拿捏。 这种色彩充满自然旷野的气息，带着原始的生命能量，如风暴般横扫Dior、Sergio Hudson、 Valentino、 Versace、 Prada等品牌的高定成衣系列， 席卷着2022 年春夏时装发布的每一个秀场。 ",
            "text-c":
              "TOPS拓弗改色膜『圣域龙胆紫』采用紫色搭配蓝色调配而成，以生于高山寒地的紫花龙胆为名，<br/>表达不同寻常的思想深度与探索力量。",
            "text-b":
              '<span style="color:#4A5299; font-weight: 600">【圣域龙胆紫】</span>源于劳尔设计体系颜色RAL 290<br/>40 45，代表了"启迪与创新"主题，属于TOPS拓<br/>弗改色膜·尊享版的<span style="color:#4A5299; font-weight: 600">圣域紫罗兰系列</span>，这款颜色有<br/>一种不寻常的光芒、活跃的深度和力量，在蓝色<br/>中融合一点红色，整体呈现蓝紫光泽，表面为亮<br/>面质感，既深邃又迷人。',
            "src-t":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-7.png",
            "src-c":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-8.png",
            "src-b":
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3-9.png"
          }
        ]
      }
    ]
  },
  // 极致色彩
  perfect: [
    {
      id: "color-1-1",
      text: "TOPS & RAL Colours Agreed On A Long-term Exclusive Strategic Cooperation",
      logo:
        "https://img.topsfilm.com/newportal/img/product/ColorChange/logo.png",
       "logo-text": "德国劳尔战略合作",
      src: "https://img.topsfilm.com/newportal/img/product/ColorChange/4-1.png"
    },
    {
      id: "color-1-2",
      text: "Follow your heart<br/>wrap your car",
      src: "https://img.topsfilm.com/newportal/img/product/ColorChange/4-2.png"
    }
  ]
};
if (isEn) {
  for (const k in colorChangeData) {
    const temV = colorChangeData[k];
    const temV2 = colorChangeDataLang[k];

    if (k === "series") {
      for (const k2 in temV) {
        if (temV[k2].titlesrc) {
          temV[k2].titlesrc = temV2[k2].titlesrc;
        }
        temV[k2].data.forEach((item, index) => {
          item["text-cn"] = temV2[k2].data[index];
        });
      }
    } else if (k === "membrane") {
      for (const k2 in temV) {
        temV[k2].forEach(item => {
          for (const k3 in temV2[k2]) {
            item[k3] = temV2[k2][k3];
          }
        });
      }
    } else {
      temV2.forEach((item, index) => {
        Object.assign(temV[index], item);
      });
    }
  }
}

// 炫彩
const colorfulData = {
  // 系列
  series: {
    id: "series",
    data: [
      {
        id: "series-1",
        "text-us": "Munich",
        "text-cn": "慕尼黑系列",
        color: "亮黑",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-1.png"
      },
      {
        id: "series-2",
        "text-us": "Munich",
        "text-cn": "慕尼黑系列",
        color: "哑光黑",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-2.png"
      },
      {
        id: "series-3",
        "text-us": "Munich",
        "text-cn": "慕尼黑系列",
        color: "烟熏色",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-3.png",
        detail: {
          duetime: 8,
          starimg:
            "https://img.topsfilm.com/newportal/img/product/Colorful/start.png",
          bgc1:
            "https://img.topsfilm.com/newportal/img/product/Colorful/bgc1-yanxun.png",
          bgc2:
            "https://img.topsfilm.com/newportal/img/product/Colorful/bgc2-yanxun.png",
          bgc2title: "汽车灯膜专享",
          bgc2des: "超亮通透，背胶优质<br/>划痕修复，抗石击"
        }
      },
      {
        id: "series-4",
        "text-us": "Munich",
        "text-cn": "慕尼黑系列",
        color: "水泥灰",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-4.png"
      },
      {
        id: "series-5",
        "text-us": "Munich",
        "text-cn": "慕尼黑系列",
        color: "水晶灰",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-5.png"
      },
      {
        id: "series-6",
        "text-us": "Berlin",
        "text-cn": "柏林红系列",
        color: "亮红",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-6.png"
      },
      {
        id: "series-7",
        "text-us": "Berlin",
        "text-cn": "柏林红系列",
        color: "熔岩橙",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-7.png"
      },
      {
        id: "series-8",
        "text-us": "Hamburg",
        "text-cn": "汉堡黄系列",
        color: "亮黄",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-8.png"
      },
      {
        id: "series-9",
        "text-us": "Rhein",
        "text-cn": "莱茵蓝系列",
        color: "亮天蓝",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-9.png"
      },
      {
        id: "series-10",
        "text-us": "Cologne",
        "text-cn": "科隆白系列",
        color: "亮白",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-10.png"
      },
      {
        id: "series-11",
        "text-us": "Stuttgart",
        "text-cn": "斯图加特珠光系列",
        color: "透明珠光",
        src:
          "https://img.topsfilm.com/newportal/img/product/Colorful/colorful-8.png"
      }
    ]
  },
  // 膜
  membrane: {
    id: "membrane",
    data: {
      top: {
        id: "membrane-top",
        src: "https://img.topsfilm.com/newportal/img/product/ColorChange/1.png",
        src1: "https://img.topsfilm.com/newportal/img/product/Colorful/1.png"
      },
      left: {
        id: "membrane-left",
        data: [
          {
            id: "membrane-3",
            src:
              "https://img.topsfilm.com/newportal/img/product/ColorChange/2.png",
            src1:
              "https://img.topsfilm.com/newportal/img/product/Colorful/2.png"
          },
          {
            id: "membrane-4",
            text: "炫彩战衣",
            style1: {
              width: "460px",
              height: "216px"
            },
            style2: {
              top: "91px",
              left: "235px",
              color: "#F4C720"
            },
            style3: {
              width: "621px",
              height: "291px"
            },
            style4: {
              top: "121px",
              left: "321px",
              color: "#F4C720"
            }
          },
          {
            id: "membrane-7",
            src:
              "https://img.topsfilm.com/newportal/img/product/ColorChange/4.png",
            src1:
              "https://img.topsfilm.com/newportal/img/product/Colorful/4.png",
            style3: {
              width: "621px",
              height: "682px"
            }
          },
          {
            id: "membrane-8",
            text: "双效合一 ",
            style1: {
              width: "460px",
              height: "182px"
            },
            style2: {
              top: "65px",
              left: "234px",
              color: "#F4C720"
            },
            style3: {
              width: "621px",
              height: "246px"
            },
            style4: {
              top: "94px",
              left: "321px",
              color: "#F4C720"
            }
          }
        ]
      },
      right: {
        id: "",
        data: [
          {
            id: "membrane-2",
            text: "致密涂层",
            style1: {
              width: "428px",
              height: "168px"
            },
            style2: {
              top: "65px",
              left: "76px",
              color: "#CF131C"
            },
            style3: {
              width: "578px",
              height: "227px"
            },
            style4: {
              top: "89px",
              left: "102px",
              color: "#CF131C"
            }
          },
          {
            id: "membrane-5",
            src:
              "https://img.topsfilm.com/newportal/img/product/ColorChange/3.png",
            src1:
              "https://img.topsfilm.com/newportal/img/product/Colorful/3.png"
          },
          {
            id: "membrane-6",
            text: "改色护车",
            style1: {
              width: "428px",
              height: "168px"
            },
            style2: {
              top: "64px",
              left: "77px",
              color: "#CF131C"
            },
            style3: {
              width: "578px",
              height: "227px"
            },
            style4: {
              top: "89px",
              left: "102px",
              color: "#CF131C"
            }
          },
          {
            id: "membrane-9",
            src:
              "https://img.topsfilm.com/newportal/img/product/ColorChange/5.png",
            src1:
              "https://img.topsfilm.com/newportal/img/product/Colorful/5.png"
          }
        ]
      }
    }
  }
};

// 天窗膜
const skylightData = {
  series: [
    {
      id: "SkyLight-1",
      titlesrc:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/colorful-text2.png",
      src:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/skylight-1.png",
      text: "天窗铠甲<br/>战神TYR帝尔系列",
      detail: {
        duetime: 6,
        title: "天窗铠甲<br/>战神TYR帝尔系列",
        topsrc:
          "https://img.topsfilm.com/newportal/img/product/SkyLight/detail-1.png",
        weilai: {
          title: "蔚来汽车<br/>原厂天窗保护膜<br/>供应商",
          src:
            "https://img.topsfilm.com/newportal/img/product/SkyLight/detail-2.png",
          tableData: [
            {
              visibleLightTransmittance: "60%",
              totalSolarBarrier: "68%",
              infraredBarrierRatio: "95%",
              UVBarrier: ">99%",
              "5gSignalPassRate": "100%",
              thickness: "8.5mil",
              warrantyPeriod: "6年"
            }
          ]
        },
        maxList: [
          "https://img.topsfilm.com/newportal/img/product/SkyLight/detail-3.png",
          "https://img.topsfilm.com/newportal/img/product/SkyLight/detail-4.png",
          "https://img.topsfilm.com/newportal/img/product/SkyLight/detail-5.png",
          "https://img.topsfilm.com/newportal/img/product/SkyLight/detail-6.png",
          "https://img.topsfilm.com/newportal/img/product/SkyLight/detail-7.png"
        ]
      }
    }
  ],
  membrane: [
    {
      id: "membrane-1",
      src:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/skylight-2.png",
      text: "蔚来汽车<br/>原厂天窗保护膜<br/>供应商"
    },
    {
      id: "membrane-2",
      src:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/skylight-3.png",
      text:
        '<div>安全力MAX</div><br/><span class="text">安全防爆 神力遁甲</span>'
    },
    {
      id: "membrane-3",
      src:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/skylight-4.png",
      text:
        '<div>防晒力MAX</div><br/><span class="text">高效防晒 冻龄永驻</span>'
    },
    {
      id: "membrane-4",
      src:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/skylight-5.png",
      text: "<div>凉爽力MAX</div><br/><span>速效降温 凉爽舒心</span>"
    },
    {
      id: "membrane-5",
      src:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/skylight-6.png",
      text:
        '<div>清晰力MAX</div><br/><span class="text">自我修复 清晰通透</span>'
    },
    {
      id: "membrane-6",
      src:
        "https://img.topsfilm.com/newportal/img/product/SkyLight/skylight-7.png",
      text:
        '<div>速度力MAX</div><br/><span class="text">无需等候 即贴即走</span>'
    }
  ]
};
if (isEn) {
  for (const k in skylightData) {
    const data = skylightData[k];
    const data2 = skylightDataLang[k];
    if (k === "series") {
      data.forEach((item, index) => {
        item.titlesrc = data2[index].titlesrc;
        item.text = data2[index].text;
        item.detail.title = data2[index].detail.title;
        item.detail.weilai.title = data2[index].detail.weilai.title;
        item.detail.maxList = data2[index].detail.maxList;
      });
    } else {
      data.forEach((item, index) => {
        item.text = data2[index];
      });
    }
  }
}
//大灯膜
const headlightFilm = {
  membrane: [
    {
      id: "membrane-1",
      src:
        "https://img.topsfilm.com/newportal/img/product/Headlight/2.png",

    },
    {
      id: "membrane-2",
      src:
        "https://img.topsfilm.com/newportal/img/product/Headlight/3.png",

    },
    {
      id: "membrane-3",
      src:
        "https://img.topsfilm.com/newportal/img/product/Headlight/4.png",

    },
    {
      id: "membrane-4",
      src:
        "https://img.topsfilm.com/newportal/img/product/Headlight/5.png",

    }
  ]
};
const customData = [
  {
    id: "170",
    Name: "A类 局部简单拉花",
    children: [
      {
        id: "custom-A-1",
        title: "国潮哪吒主题",
        src: ["/A/1.png"]
      },
      {
        id: "custom-A-2",
        title: "卡通宇航员主题",
        src: ["/A/2.png", "/A/3.png"]
      },
      {
        id: "custom-A-3",
        title: "篮球高手主题",
        src: ["/A/4.png", "/A/5.png"]
      },
      {
        id: "custom-A-4",
        title: "赛道风潮主题",
        src: [
          "/A/6.png",
          "/A/7.png",
          "/A/8.png",
          "/A/9.png",
          "/A/10.png",
          "/A/11.png"
        ]
      }
    ]
  },
  {
    id: "171",
    Name: "B类 全车简单拉花",
    children: [
      {
        id: "custom-B-1",
        title: "滑雪运动主题",
        src: ["/B/1.png"]
      },
      {
        id: "custom-B-2",
        title: "科幻未来主题",
        src: ["/B/2.png"]
      }
    ]
  },
  {
    id: "172",
    Name: "C类 全车拉花涂装",
    children: [
      {
        id: "custom-c-1",
        title: "曼巴精神主题",
        src: ["/C/1.png"]
      },
      {
        id: "custom-c-2",
        title: "越野运动主题",
        src: ["/C/2.png", "/C/3.png", "/C/4.png", "/C/5.png"]
      }
    ]
  },
  {
    id: "173",
    Name: "D类 全车彩绘涂装",
    children: [
      {
        id: "custom-D-1",
        title: "拓拓主题",
        src: ["/D/1.png", "/D/2.png", "/D/3.png"]
      },
      {
        id: "custom-D-2",
        title: "国潮哪吒主题",
        src: ["/D/4.png"]
      },
      {
        id: "custom-D-3",
        title: "越野运动主题",
        src: ["/D/5.png", "/D/6.png", "/D/7.png", "/D/8.png", "/D/9.png"]
      },
      {
        id: "custom-D-4",
        title: "滑雪运动主题",
        src: ["/D/10.png", "/D/11.png", "/D/12.png"]
      },
      {
        id: "custom-D-5",
        title: "科幻未来主题",
        src: ["/D/13.png", "/D/14.png", "/D/15.png"]
      },
      {
        id: "custom-D-6",
        title: "多色渐变系列",
        src: [
          "/D/16.png",
          "/D/17.png",
          "/D/18.png",
          "/D/19.png",
          "/D/20.png",
          "/D/21.png",
          "/D/22.png",
          "/D/23.png",
          "/D/24.png",
          "/D/25.png",
          "/D/26.png",
          "/D/27.png"
        ]
      }
    ]
  }
];

export {
  paintDetailList,
  paintStandardList,
  GData,
  windowMembraneList,
  colorChangeData,
  colorfulData,
  customData,
  skylightData,
  headlightFilm,
  productNameDic
};



//////////////////
// WEBPACK FOOTER
// ./config/product-dict.js
// module id = hSZE
// module chunks = 0